export const messages = {
  en: {
    scheduleClassesPage: {
      searchConditions: 'Search Conditions',
      scheduleTable: 'Schedule Table',
      staffNamePlaceholder: 'Please enter staff name',
      schedulePlaceholder: 'Please select schedule',
      selectSchedule: 'Select Schedule',
      datePlaceholder: 'Please enter date YYYY-MM',
      orgPlaceholder: 'Required, please select organization',
      staffName: 'Staff Name',
      day: 'Day',
      rest: 'Rest',
      selectOrg: 'Select Organization'
    }
  },
  zh: {
    scheduleClassesPage: {
      searchConditions: '查询条件',
      scheduleTable: '排班表',
      staffNamePlaceholder: '请输入员工名称',
      schedulePlaceholder: '请选择班次',
      selectSchedule: '请选择班次',
      datePlaceholder: '请输入日期 YYYY-MM',
      orgPlaceholder: '必填，请选择关联组织',
      staffName: '员工名称',
      day: '日',
      rest: '休息',
      selectOrg: '选择组织'
    }
  }
}